import { Validators } from "@angular/forms";
import { User } from "./user-model";
import { Profile } from "./profile-model";
import { environment } from "src/environments/environment";
import { AwsService } from "../services/aws/aws.service";
import { Studio } from "./studio-model";

export class Reservation {
  id?: number;
  start_date?: string;
  end_date?: string;
  total_amount?: number;
  paid_amount?: number;
  deposit_amount?: number;
  type?: string;
  status?: string;
  artist: Profile;
  studio: Studio;
  description?: string;
  token?: string;
  studio_name: String = "";
  artist_full_name: String = "";
  artist_email: string = "";
  show_button_accpet: boolean = false;
  show_button_cancel: boolean = false;
  horaires: any = 0;
  nbr_hours_reserved: number = 0;
  payment_status?: string;
  payment_type?: string;
  total: number =0;
  pay: number = 0;

  constructor(data: Partial<Reservation>) {
    if (data) {
      Object.assign(this, data);

      if (data.id !== undefined) {
        if (data.artist != undefined && data.artist != null) {
          this.artist = new Profile(data.artist as Partial<Profile>);
        }
        if (data.studio != undefined && data.studio != null) {
          this.studio = new Studio(data.studio as Partial<Studio>);
        }
      }
    }
  }

  static attributeToJson(item: any) {
    let obj = item.attributes;
    obj["id"] = item.id;

    if (item.attributes.artist) {
      if (item.attributes.artist.data != null) {
        let objArtist = item.attributes.artist.data.attributes;
        objArtist["id"] = item.attributes.artist.data.id;
        obj["artist"] = objArtist;
      } else {
        obj["artist"] = null;
      }
    } else {
      obj["artist"] = null;
    }

    if (item.attributes.studio) {
      if (item.attributes.studio.data != null) {
        let objStudio = Studio.attributeToJson(item.attributes.studio.data);
        obj["studio"] = objStudio;
      } else {
        obj["studio"] = null;
      }
    } else {
      obj["studio"] = null;
    }

    obj["artist_full_name"] =
      obj["artist"] != null ? obj["artist"].full_name : "---";
    obj["artist_phone"] = obj["artist"] != null ? obj["artist"].country_code_phone + obj["artist"].phone : "---";
    obj["studio_name"] = obj["studio"] != null ? obj["studio"].name : "---";

    obj["nbr_hours_reserved"] = obj["horaires"].length;

    return obj;
  }

  static responseToJson(item: any) {
    let obj = item;
    obj["id"] = item.id;

    if (item.artist) {
      if (item.artist != null) {
        let objArtist = item.artist;
        objArtist["id"] = item.artist.id;
        obj["artist"] = objArtist;
      } else {
        obj["artist"] = null;
      }
    } else {
      obj["artist"] = null;
    }

    if (item.studio) {
      if (item.studio != null) {
        let objStudio = item.studio;
        objStudio["id"] = item.studio.id;
        obj["studio"] = objStudio;
      } else {
        obj["studio"] = null;
      }
    } else {
      obj["studio"] = null;
    }

    obj["artist_full_name"] =
      obj["artist"] != null ? obj["artist"].full_name : "---";
    obj["studio_name"] = obj["studio"] != null ? obj["studio"].name : "---";
    obj["nbr_hours"] = obj["horaires"] != null ? obj["horaires"].length : "---";

    return obj;
  }

  static get_title() {
    return "";
  }

  static get_inputs() {
    return [];
  }

  static get_form() {
    return {};
  }

  static get_relations() {
    return [];
  }
}
